module.exports = __webpack_public_path__ + "img/imag8.823493f2.png";